
import React from 'react';
import Plot from 'react-plotly.js';
import { handleRelayout } from './utils';


export function MapComponent({mapCenter, zoomLevel,  updateMapView, mapboxStyle }) {

  const plotData = {
    type: 'scattermapbox',
    lat: [mapCenter.lat],
    lon: [mapCenter.lon],
    mode: 'markers',

    marker: {
      size: 14,       // Adjust size for visibility
      color: 'red',   // Red color for the cross
    },
    hoverinfo: 'none'
  };

  const plotLayout = {
      autosize: true,
      hovermode: 'closest',
      mapbox: {
          style: mapboxStyle || 'open-street-map',
          center: mapCenter,
          zoom: zoomLevel,
      },
      margin: {
          l: 0,
          r: 0,
          b: 0,
          t: 0,
          pad: 4
      }
  };

  const plotStyle = {
      height: '100%',
  };

  const plotConfig = {
      displayModeBar: false
  };




  return (
<div style={{ position: 'relative', touchAction: 'none', height: '80vh' }}>
          <Plot
            data={[plotData]}
            layout={plotLayout}
            style={plotStyle}
            config={plotConfig}
            onRelayout={handleRelayout(updateMapView)}
          />
  </div>
  );
}




